import React from "react"

import './button.css'

const Button = ({ btnStyle="btn-brand-color-linear", classNameVal='', handleLoadMore, text="Load More" }) => {
    return (
        <div className="text-center btn-action">
            <button className={`btn ${btnStyle} ${classNameVal}`} onClick={handleLoadMore && handleLoadMore}>{text}</button>
        </div>
    )    
}
export default Button